import React, { useState, useEffect } from "react";
import './Banner.css';

export default function Banner({ width, height, bannerImageUrl = './Banner.png' }) {
    const [bannerExists, setbannerExists] = useState(false);
  
    useEffect(() => {
      const img = new Image();
      img.src = bannerImageUrl;
      img.onload = () => setbannerExists(true);   // if loaded successfully
      img.onerror = () => setbannerExists(false); // if loading failed
    }, [bannerImageUrl]);
  
    if (!bannerExists) return null; // no banner if image missing
  
    return (
      <div className="w-full" 
      style={{
        maxWidth: width ? `${width}px` : '100%',
        height: height ? `${height}px` : '100%',
      }}>
         <div className="rounded-lg animate-glowing-border">
        <img
          src={bannerImageUrl} 
          alt="Special Offer"
          className="w-full h-full object-contain"
        />
        </div>
      </div>
    );
  }